import { render, staticRenderFns } from "./UsersResetPassword.vue?vue&type=template&id=3adcba33&scoped=true"
import script from "./UsersResetPassword.vue?vue&type=script&lang=js"
export * from "./UsersResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adcba33",
  null
  
)

export default component.exports